import { render, staticRenderFns } from "./DonutChart29.vue?vue&type=template&id=3c4b7a53&scoped=true&"
import script from "./DonutChart29.vue?vue&type=script&lang=js&"
export * from "./DonutChart29.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b7a53",
  null
  
)

export default component.exports